// @ts-nocheck
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { observer } from "mobx-react";
import RegisterOrderRequest from "./register-order-request";

type Props = RouteComponentProps<{ entityId?: string }>;

@observer
export class RegisterOrderRequestManagement extends React.Component<Props> {
  static PATH = "/registerOrderRequest";
  static NEW_SUBPATH = "new";

  render() {
    const { entityId } = this.props.match.params;

    return (
      <>
        {entityId &&
          <RegisterOrderRequest entityId={entityId} />
        }
      </>
    );
  }
}
